// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__3AazV","tab":"TabNav_tab__1ch2I","link":"TabNav_link__2IefX","selectedLink":"TabNav_selectedLink__12RY2","disabled":"TabNav_disabled__3l1nE"};